import styled from 'styled-components';
import colors from 'theme/colors';

export const TableOverflow = styled.div`
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100vh - 250px);
`;

export const Table = styled.table`
  width: 100%;
  color: ${colors.white};
  border-collapse: separate;
  border-spacing: 0 12px;
  font-size: 14px;
  padding: 0 12px;
`;

export const TableHeader = styled.thead`
  th {
    padding: 8px;
    height: 44px;
    text-align: left;
    user-select: none;
    cursor: pointer;
    font-weight: 500;
  }
`;

export const TableBody = styled.tbody`
  tr {
    position: relative;
    height: 50px;
  }

  td {
    position: relative;
    padding: 0;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 2px;
      height: 34px;
      background-color: ${colors.dark};
    }

    &:first-child {
      border-top-left-radius: 0.6rem;
      border-bottom-left-radius: 0.6rem;
    }

    &:last-child {
      border-top-right-radius: 0.6rem;
      border-bottom-right-radius: 0.6rem;
    }
  }
`;

const depthGradients: Record<number, string> = {
  0: '#272A38;',
  1: '#2c303f',
  2: '#333846',
};

export const TableCell = styled.div<{ depth?: number }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding 8px 16px;
  height: 50px;
  background: ${({ depth = 0 }) => depthGradients[depth] || depthGradients[0]};
  border-radius: inherit;
`;
